import { render, staticRenderFns } from "./YourNeedsSection.vue?vue&type=template&id=64fc1293&"
import script from "./YourNeedsSection.vue?vue&type=script&lang=js&"
export * from "./YourNeedsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports